<template>
<x-y-chart-v2
  v-if="isShow"
  ref="chart"
  :data-config="newDataConfig"
  :unit-prop="unitProp"
  chart-type="line"
  :stack-type="0"
  :download-name="downloadName"
  :chart-min-height="chartMinHeight"
  :max-legend-num="maxLegendNum"
  chart-height="auto"
  selected-change-with-data-changed
  need-resize
>
  <template #toolbar-after>
    <slot name="toolbar-after" />
  </template>
</x-y-chart-v2>
</template>

<script>
import XYChartV2 from '../../DataChart/XYChartV2'
import ChartStyle from '../../DataChart/ChartStyle'
import WindDirectionUtil from '../../../model/WindDirectionUtil'

export default {
  name: 'DimensionWeatherChartV2',
  components: {XYChartV2},
  props: {
    dataConfig: {
      required: true,
      type: Object
    },
    dimension: {
      required: true,
      type: Number
    },
    unitProp: {
      required: true,
      type: String
    },
    downloadName: {
      type: String
    },
    chartMinHeight: {
      type: String,
      default: '400px'
    },
    maxLegendNum: {
      type: Number
    }
  },
  data: () => ({
    newDataConfig: null
  }),
  computed: {
    isShow () {
      return this.dimension === 0 || this.dataConfig.id !== '1013'
    }
  },
  methods: {
    buildNewDataConfig (dataConfig) {
      let {name, dimensions, seriesMap} = dataConfig

      if (this.dimension === 0) {
        const windDirectSeriesMap = seriesMap['1013']
        if (seriesMap['1012'] && windDirectSeriesMap) {
          dimensions = dimensions.reduce((list, dimension) => {
            let {id} = dimension

            if (id !== '1013') {
              if (id === '1012') {
                dimension = {
                  ...dimension,
                  name: '风速风向',
                  getTooltip: (dimension, marker, seriesName, value, seriesId, data = {}, unitProp, columns, add, dataTime) => [{
                    marker,
                    seriesName: '风速',
                    value: Number.isFinite(value) ? value : '--',
                    unit: dimension[unitProp],
                    displayFlag: data.displayFlag
                  }, {
                    marker,
                    seriesName: '风向',
                    value: data && Number.isFinite(data.windDirect) && Number.isFinite(value) ? this.windDirectionUtil.getWindDirName(data.windDirect) : '--',
                    unit: '°',
                    displayFlag: (windDirectSeriesMap[dataTime] || {}).displayFlag
                  }],
                  seriesParam: {
                    type: 'line',
                    symbol: `image://data:image/svg+xml;base64,${btoa(`<svg viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-50.000000, -60.000000)" fill-rule="nonzero" fill="#795548"><polygon transform="translate(58.000000, 68.000000) scale(1, -1) rotate(90.000000) translate(-58.000000, -68.000000) " points="50 73 55.3076923 68 50 63 66 68"></polygon></g></g></svg>`)}`,
                    symbolSize: 20,
                    color: '#795548',
                    showAllSymbol: true,
                    z: 3
                  }
                }
              }

              list.push(dimension)
            }

            return list
          }, [])
        }
      } else if (dataConfig.id === '1012') {
        name = '风速风向'
        let {COLORS} = ChartStyle
        let colorsLen = COLORS.length
        dimensions = dimensions.map((dimension, index) => {
          let color = COLORS[index % colorsLen]

          return {
            ...dimension,
            getTooltip: (dimension, marker, seriesName, value, seriesId, data, unitProp) => [{
              marker,
              seriesName: `${seriesName}-风速`,
              value: Number.isFinite(value) ? value : '--',
              unit: dimension[unitProp]
            }, {
              marker,
              seriesName: `${seriesName}-风向`,
              value: data && Number.isFinite(data.windDirect) ? this.windDirectionUtil.getWindDirName(data.windDirect) : '--',
              unit: '°'
            }],
            seriesParam: {
              type: 'line',
              symbol: `image://data:image/svg+xml;base64,${btoa(`<svg viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-50.000000, -60.000000)" fill-rule="nonzero" fill="${color}"><polygon transform="translate(58.000000, 68.000000) scale(1, -1) rotate(90.000000) translate(-58.000000, -68.000000) " points="50 73 55.3076923 68 50 63 66 68"></polygon></g></g></svg>`)}`,
              symbolSize: 20,
              color,
              showAllSymbol: true,
              z: 3
            }
          }
        })
      }

      this.newDataConfig = Object.freeze({
        ...dataConfig,
        name,
        dimensions
      })
    },
    getChartComponent () {
      return this.$refs.chart.getChartComponent()
    }
  },
  watch: {
    dataConfig: {
      immediate: true,
      handler (dataConfig) {
        if (this.isShow) {
          this.buildNewDataConfig(dataConfig)
        }
      }
    }
  },
  created () {
    this.windDirectionUtil = new WindDirectionUtil(WindDirectionUtil.WIND_DIRECTION_NAMES_8)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Data/ChartWrapper/DimensionWeatherChartV2.vue